import Link from "next/link";
import FrontProducts from "../components/front-products/front-products";


export default function NotFound() {
  return (
    <>
      <div style={{ textAlign: "center", padding: "50px" }}>
        <h1>404 - Siden finnes ikke</h1>
        <p>Beklager, vi finner ikke siden du lette etter. Kanskje den har flyttet seg, eller så var det en liten skrivefeil i adressen.</p>
        <p><strong>Ta gjerne turen tilbake til <Link href="/" aria-label="Fant ikke siden. Gå til forsiden.">forsiden</Link>, eller bruk menyen for å finne det du leter etter.</strong></p>
      </div>
      <br/>
      <FrontProducts />
    </>
  );
}